module.exports = __webpack_public_path__ + "static/henho9-5ef806b64443f618583077a4fb75f21a.jpg";